import { isMobileApp } from 'webui/utils/version';
import * as Promise from 'promise';
const start_event = isMobileApp() ? 'deviceready' : 'DOMContentLoaded';
let cordovaReady = false;
let onReady = null;
function onStartEvent() {
    cordovaReady = true;
    onReady?.();
    document.removeEventListener(start_event, onStartEvent);
}
document.addEventListener(start_event, onStartEvent);
const cordovaIsReady = new Promise((resolve) => {
    onReady = resolve;
});
export function waitForCordovaReady() {
    if (cordovaReady) {
        return Promise.resolve();
    }
    return cordovaIsReady;
}
// like Python deffered
// const waiters: (() => void)[] = [];
// function onStartEvent() {
//     cordovaReady = true;
//     for (const resolve of waiters) {
//         resolve();
//     }
//     document.removeEventListener(start_event, onStartEvent);
// }
//
// document.addEventListener(start_event, onStartEvent);
//
// export function waitForCordovaReady(): Promise<void> {
//     if (cordovaReady) {
//         return Promise.resolve();
//     }
//     return new Promise((resolve) => waiters.push(resolve));
// }
